import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
//import { API_BASE_URL } from "../../config";
import Navbar4 from "../../Components/Navbar4";
import './ForgetPassword.css';
import { API_BASE_URL } from '../../config';

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const navigate = useNavigate();

  const generatePassword = () => {
    return Math.random().toString(36).slice(-8); // Generates a random 8-character password
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setMessage("Please enter your email.");
      return;
    }

    const tempPassword = generatePassword();
    setNewPassword(tempPassword);

    try {
      const response = await axios.post(`${API_BASE_URL}/ForgotPassword.php`, { 
        email, 
        newPassword: tempPassword 
      });
      
      if (response.data.status === "success") {
        setMessage("Password reset successful. Sending email...");
        handleShow();
      } else {
        setMessage("Failed to reset password. Please try again.");
      }
    } catch (error) {
      setMessage("Something went wrong. Please try again.");
    }

      try {
        const emailBody = `
          Dear User,<br /><br />
          Your password has been reset successfully. Below are your new login credentials:<br /><br />
          <strong>Email:</strong> ${email}<br />
          <strong>New Password:</strong> ${tempPassword }<br /><br />
          Please log in and change your password as soon as possible for security reasons.<br /><br />
          Best regards,<br />
          Support Team
        `;
  
        const emailResponse = await axios.post(`${API_BASE_URL}/Email.php`, {
          email,
          subject: "Password Reset Successful",
          message: emailBody,
          attachment: new Blob([newPassword], { type: "text/plain" })
        });
  
        if (emailResponse.data.status === "success") {
            alert(`An email has been sent to ${email} with your new password. Please check your inbox.`);
          navigate("/login"); // Redirect after sending email
        } else {
          alert("Failed to send email: " + emailResponse.data.message);
        }
      } catch (error) {
        alert("Error sending email. Please try again.");
      }
    };

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);


  return (
    <div>
        <Navbar4/>
    <div className="forgot-password-container">
     
      <div className="forgot-password-box">
        <h2>Forgot Password</h2>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formEmail" className="form-group">
            <Form.Label>Enter your email</Form.Label>
            <Form.Control
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              required
            />
          </Form.Group>
          <Button variant="primary" type="submit" className="mt-3">Reset Password</Button>
        </Form>
        {message && <p className="forgot-password-message">{message}</p>}
      </div>
    </div>
    </div>
  );
  
}